/**
 * Content item discriminator keys used by parseContentItem to branch on raw payload shape.
 * Use these constants instead of string literals so typos are caught at compile time.
 */
export const CONTENT_ITEM_KEYS = {
  IMAGE: "image",
  WIDTH: "width",
  TEXT: "text",
  KEY: "key",
  YEAR: "year",
  COLUMNS: "columns",
  ROWS: "rows",
  COLUMN_NAMES: "columnNames",
  CELLS: "cells",
  CELL: "cell",
  CHART_TYPE: "chartType",
  MONEY_IN: "moneyIn",
  MONEY_OUT: "moneyOut",
  SAVINGS_VARIATION_LINK: "savingsVariationLink",
  DEBT_VARIATION_LINK: "debtVariationLink",
  MONTH_VARIABLE: "monthVariable",
  LABEL: "label",
  CONTENT_FROM: "contentFrom",
  /** Conditional CTA: `options: [{ condition, cta }]` */
  OPTIONS: "options",
} as const;

/** Advisor content field keys (e.g. in interaction blueprint payload). */
export const ADVISOR_CONTENT_KEYS = {
  SUMMARY: "summary",
} as const;
